export { default } from './SeguroAuto25Facilidades';
